import styled from "@emotion/styled";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  TimePicker,
  Upload,
} from "antd";
import Button from "atoms/Button";
import { CALL_API } from "common/API";
import { displayErrorModal } from "common/common";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import { concat, find, get, includes, intersection, result } from "lodash";
import moment from "moment";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { ReactComponent as Fileupload } from "../../assets/fileupload.svg";

import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setLeaveList } from "redux/actions";
import {
  getAllDepartmentList,
  getClientid,
  getLeaveCategoryList,
  // getLeaveList,
  getRoleList,
  getSelectedDepartmentId,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { bindActionCreators } from "redux";
import { UploadOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important; /* Adjust the value as needed */
  }
`;
const StyledInput = styled(Input)`
  border-radius: 5px !important; /* Adjust the value as needed */
`;
const StyledTextArea = styled(Input.TextArea)`
  border-radius: 5px !important; /* Adjust the value as needed */
`;
const StyledModal1 = styled(Modal)``;
const StyledModal = styled(Modal)`
.divstyl{
display:flex;
align-items:center;
justify-content:end;
}
 .success-modal {
    align-items: center;
    display: flex;
  
    padding-top:40px;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
  border-radius:5px;
    width: 100%;
  }
  .ant-upload {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: "tnum";
    outline: 0;
    width: 100%;
    text-align: center;
  }
    .small-text{
    #636980 !important;
    }
`;

function LeaveForm({
  isModalVisible = false,
  closeModal,
  userInfo,
  userId,
  userList,
  details,
  selectedIncidentId,
  ClientId,
  page = "",
}) {
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo?.userid
  );
  const history = useHistory();
  const IncidentTypeOption = [
    { id: 1, value: "Workplace Injury" },
    { id: 2, value: "Hazardous Material Exposure" },
    { id: 3, value: "Vehicle Accident" },
    { id: 4, value: "Fire or Explosion" },
    { id: 5, value: "Medical Emergency" },
    { id: 6, value: "Near miss" },
  ];

  const { TextArea } = Input;
  const containerRef = useRef(null);
  const [showLoader, toggleLoader] = useState(false);
  const [form] = Form.useForm();
  const [fileData, setFileData] = useState([]);
  const resetForm = () => {
    form.resetFields();
    setFileData([]);
    form.setFieldsValue({
      date: null,
    });
  };

  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      form.setFieldsValue({
        type: details?.type || "",
        incidentlocation: details?.incidentlocation || "",
        date: details?.date
          ? moment(details.date)
          : momentDate(getKenyanDateTime()),
        time: details?.time ? moment(details.time, "HH:mm:ss") : "",
        description: details?.description || "",
        remark: details?.remark || "",
      });

      if (Array.isArray(details.evidence) && details.evidence.length > 0) {
        const extractedFiles = details.evidence.map((file) => ({
          base64: file.base64Data || "", // Use base64 from response
          fileType: file.contentType || "", // Use content type from response
          name: file.fileName, // Use fileName directly from response
          url: file.fileUrl, // Keep the URL for download/view
        }));

        setFileData(extractedFiles);
      }
    }
  }, [details, isModalVisible]);

  // Include `form` in the dependency array
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false); // Add this state
  const getHongKongTime = () => {
    return new Date().toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" });
  };

  // Convert to ISO format
  const getHongKongISOTime = () => {
    const now = new Date();
    const hongKongTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" })
    );
    return hongKongTime.toISOString();
  };
  const handleSubmit = async (values) => {
    toggleLoader(true);
    try {
      const formattedTime = values?.time ? moment(values?.time).format("HH:mm:ss") : null;
      const file = values?.attachment;
      const payload = {
        clientId: ClientId,
        userId: userInfo?.userid,
        type: values?.type,
        name: filteruser[0]?.fullname,
        employeeId: filteruser[0]?.employeeid,
        date: values?.date.format("YYYY-MM-DD"),
        time: values?.time.format("HH:mm:ss"),
        incidentlocation: values?.incidentlocation,
        description: values?.description,
        insertedby: userInfo?.insertedby,
        evidence: fileData
          ? fileData.map((item) => ({
            fileName: item.name,
            contentType: item.fileType,
            base64Data: item.base64,
          }))
          : null,
        status: "Waiting for Review",
        actiontimeline: [
          {
            insertedAt: new Date().toISOString(),
            insertedby: userInfo?.userid,
            comment: values?.comment,
            actionmoveon: values?.actionmoveon,
          },
        ],
        insertedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      const payloadpatch = {
        clientId: ClientId,
        userId: details?.userId,
        name: details?.name,
        employeeId: details?.employeeId,
        type: values?.type,
        date: values?.date.format("YYYY-MM-DD"),
        time: formattedTime,
        incidentlocation: values?.incidentlocation,
        description: values?.description,
        insertedby: userInfo?.insertedby,
        actiontimeline: details?.actiontimeline,
        insertedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        status: details?.status,
        // AFTER (in payloadpatch):
        evidence: fileData && fileData.length > 0
          ? fileData.map((item) => {
            // If base64 is missing, find the original evidence entry by filename
            if (!item.base64) {
              const original = details?.evidence?.find(e => e.fileName === item.name);
              return {
                fileName: item.name,
                contentType: item.fileType || original?.contentType,
                base64Data: original?.base64Data || "",
                fileUrl: item.url || original?.fileUrl,
              };
            }
            return {
              fileName: item.name,
              contentType: item.fileType,
              base64Data: item.base64,
            };
          })
          : details?.evidence || null,
      };

      let response;
      if (details && Object.keys(details).length > 0) {
        response = await CALL_API(
          `incident/${ClientId}/${details?.incidentId}`,
          "patch",
          payloadpatch
        );
        message.success("Incident updated successfully!");
        closeModal(false);
        setIsSavedModalOpen(true);
        setTimeout(() => {
          setIsSavedModalOpen(false); // Close the modal after a delay
          closeModal(false); // Close the main modal
        }, 2000);
        history.push("/myincident");
      } else {
        response = await CALL_API("incident", "post", payload);
        message.success("Incident submitted successfully!");
        resetForm();
        closeModal(false);
        setIsSavedModalOpen(true); // Show the modal after successful submission
        setTimeout(() => {
          setIsSavedModalOpen(false);

          if (page === "myincident") {
            history.push("/myincident");
          }
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Failed to submit the incident. Please try again.");
    } finally {
      toggleLoader(false); // Stop loading
    }
  };

  const handleRemove = () => {
    setFileData(null);
  };

  return (
    <>
      <StyledModal
        title={
          details && Object.keys(details).length > 0
            ? "Editing Incident"
            : "Reporting Incident"
        }
        visible={isModalVisible}
        onCancel={() => {
          resetForm();
          closeModal(false);
        }}
        width={600}
        footer={[]}
      >
        <Form
          form={form}
          name="incidentform"
          layout="vertical"
          initialValues={{
            incidentId: selectedIncidentId || "",
            type: "",
            incidentlocation: "",
            date: momentDate(getKenyanDateTime()),
            time: "",
            description: "",
            remark: "",
          }}
          onFinish={handleSubmit}
        >
          <Row gutter={20}>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Incident Type"
                name="type"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "Incident type is required",
                  },
                ]}
              >
                <StyledSelect
                  showSearch
                  placeholder="Incident type"
                  optionFilterProp="value"
                  options={IncidentTypeOption}
                  fieldNames={{ label: "value", value: "value" }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="incidentlocation"
                label="Incident Location"
                rules={[
                  { required: true, message: "Incident Location is required" },
                ]}
              >
                <StyledInput type="text" placeholder="" maxLength={50} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Date"
                name="date"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "Date is required",
                  },
                ]}
              >
                <DatePicker
                  className="form-datepicker"
                  format="DD-MM-YYYY"
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label="Time"
                name="time"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "Time is required",
                  },
                ]}
              >
                <TimePicker
                  defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} ref={containerRef}>
              <Form.Item
                className="mb-0 pb-0"
                label="Detailed Description"
                name="description"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: "Description is required",
                  },
                ]}
              >
                <StyledTextArea
                  placeholder="Type something.."
                  maxLength={250}
                  autoSize={{ minRows: 2, maxRows: 6 }}
                />
              </Form.Item>
              <span>
                <small className="small-text">Maximum 250 characters</small>
              </span>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item className="w-100 mt-2" label="Attachment (Optional)" name="attachment">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: fileData.length === 0 ? "center" : "flex-start",
                    gap: "8px",
                    border: "1px solid #D0D5DD",
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#E8EDFD",
                    minHeight: "60px",   // important 🔥
                  }}
                >

                  {fileData.length === 0 ? (
                    // Show Upload File text when no files are attached
                    <Upload
                      customRequest={({ file, onSuccess, onError }) => {
                        const maxSize = 25 * 1024 * 1024; // 25MB limit

                        if (file.type === "video/mp4") {
                          message.error("MP4 video files are not allowed.");
                          onError?.("MP4 files are not allowed.");
                          return;
                        }

                        if (file.size > maxSize) {
                          message.error("File size should not exceed 25MB.");
                          onError?.("File size too large.");
                          return;
                        }

                        const reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = () => {
                          const base64Data = reader.result.split(",")[1];
                          onSuccess?.();
                          setFileData((prev) => [
                            ...(Array.isArray(prev) ? prev : []),
                            {
                              base64: base64Data,
                              fileType: file.type,
                              name: file.name,
                            },
                          ]);
                        };

                        reader.onerror = (error) => {
                          console.error("File read error:", error);
                          message.error("File read error.");
                          onError?.("File read error");
                        };
                      }}
                      showUploadList={false}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          cursor: "pointer",
                          height: "40px",
                        }}
                      >
                        <Fileupload
                          style={{
                            fontSize: "24px",
                            color: "#4759C4",
                            marginBottom: "0px",
                            marginRight: "5px",
                          }}
                        />
                        <span
                          style={{
                            color: "#4759C4",
                            fontWeight: "500",
                            fontSize: "14px",
                          }}
                        >
                          Upload File
                        </span>
                      </div>
                    </Upload>


                  ) : (
                    // Show uploaded files and "+" button when files exist
                    <>
                      {fileData.map((file, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            padding: "8px",
                            borderRadius: "6px",
                            // border: "1px solid #D0D5DD",
                          }}
                        >
                          <span style={{ color: "#000", fontSize: "14px" }}>{file.name}</span>
                          <CloseOutlined
                            style={{
                              fontSize: "14px",
                              color: "#6E6E6E",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFileData((prev) => prev.filter((_, i) => i !== index));
                            }}
                          />
                        </div>
                      ))}

                      {/* "+" Button only when files are attached */}
                      <Upload
                        customRequest={({ file, onSuccess, onError }) => {
                          const maxSize = 25 * 1024 * 1024; // 25MB limit

                          if (file.type === "video/mp4") {
                            message.error("MP4 video files are not allowed.");
                            onError?.("MP4 files are not allowed.");
                            return;
                          }

                          if (file.size > maxSize) {
                            message.error("File size should not exceed 25MB.");
                            onError?.("File size too large.");
                            return;
                          }

                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess?.();
                            setFileData((prev) => [
                              ...(Array.isArray(prev) ? prev : []),
                              { base64: base64Data, fileType: file.type, name: file.name },
                            ]);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                            message.error("File read error.");
                            onError?.("File read error");
                          };
                        }}
                        showUploadList={false}
                      >
                        <Button
                          icon={<PlusOutlined style={{ color: "blue" }} />}
                          style={{
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgb(228, 231, 243)",
                            borderRadius: "6px",
                          }}
                        />
                      </Upload>

                    </>
                  )}
                </div>
              </Form.Item>

            </Col>
            <Col xs={24} sm={24} md={24}>
              <div className="divstyl">
                <ButtonOutlined
                  className=""

                  onClick={() => {
                    resetForm(); // Reset the form
                    closeModal(false); // Close the modal
                  }}
                >
                  Cancel
                </ButtonOutlined>
                <ButtonFilled className="m-0" style={{ height: "32px" }} loading={showLoader} htmlType="submit">
                  {details && Object.keys(details).length > 0 ? "Save Changes" : "Submit"}
                </ButtonFilled>
              </div>
            </Col>
          </Row>
        </Form>
      </StyledModal>
      <StyledModal
        width={220}
        height={20}
        open={isSavedModalOpen}
        onCancel={() => setIsSavedModalOpen(false)}
        footer={false}
        closable={false}
        style={{ marginTop: "130px" }}
      >
        <div className="success-modal">
          <Tick />
          <p className="sent-successfully">
            {details && Object.keys(details).length > 0 ? "Saved" : "Submitted"}
          </p>
        </div>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  // leaveList: getLeaveList(state),
});
export default connect(mapStateToProps)(LeaveForm);

